import { Outlet } from '@remix-run/react'
import React from 'react'
import { Col, Container, Row } from 'reactstrap'

export default function AuthLayout() {
  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Outlet />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}
